// extracted by mini-css-extract-plugin
module.exports = {"story":"StoryCard_story__1lmD3","position":"StoryCard_position__7SBDX","name":"StoryCard_name__NaRMb","readMore":"StoryCard_readMore__UkO_B","details":"StoryCard_details__OVrZI"};